import {isNotNil} from 'ramda';

import {ApiMakeModelWithMake} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export interface VehicleLookupMaps {
  modelToMakeMap: Map<string, string>;
  modelFamilyToMakeMap: Map<string, string>;
}

export function buildVehicleLookupMaps(
  makesWithModels: ApiMakeModelWithMake[] | Nullish
): VehicleLookupMaps {
  const modelToMakeMap = new Map<string, string>();
  const modelFamilyToMakeMap = new Map<string, string>();

  for (const make of makesWithModels ?? []) {
    for (const model of make.models ?? []) {
      modelToMakeMap.set(model.model, make.make);
      const familyId = model.model_group?.group;
      if (isNotNil(familyId)) {
        modelFamilyToMakeMap.set(familyId, make.make);
      }
    }
  }

  return {modelToMakeMap, modelFamilyToMakeMap};
}
